import type { CSSProperties } from "react";

export type UndrawIllustrationProps = {
  className?: string;
  /** Couleur d’accent (CSS). Si omis, la classe `text-primary` du thème s’applique. */
  accentColor?: string;
  /** Hauteur cible en px (largeur proportionnelle). */
  size?: number;
};



export const undrawIllustrationStyle = ({
  accentColor,
  size = 112,
}: Pick<UndrawIllustrationProps, "accentColor" | "size">): CSSProperties => {
  return {
    height: size,
    width: "auto",
    maxWidth: "100%",
    ...(accentColor ? { color: accentColor } : {}),
  };
}
